var map = {
	"./icon_1.png": 826,
	"./icon_10.png": 827,
	"./icon_11.png": 828,
	"./icon_12.png": 829,
	"./icon_2.png": 830,
	"./icon_3.png": 831,
	"./icon_4.png": 832,
	"./icon_5.png": 833,
	"./icon_6.png": 834,
	"./icon_7.png": 835,
	"./icon_8.png": 836,
	"./icon_9.png": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 825;